module.exports = __webpack_public_path__ + "img/1.e93fa49d.jpg";